import P2PRegistrationApp from "./P2PRegistrationApp";
import Routes from "./Routes";
import ConnectedP2PRegistrationInjection from "./ConnectedP2PRegistrationInjection";
import ConnectedInjections from "./ConnectedInjections";

export { Routes, ConnectedP2PRegistrationInjection, ConnectedInjections };
export default P2PRegistrationApp;
